import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'utils/api/axios'
import AxiosUtils from 'utils/api/axiosUtils'
import { Message, MessageSeverity } from 'constants/message'
import { HTTP_CODES } from 'constants/constants'
import './widgetProgression.css'
import GaugeTasksProgression from './components/gaugeTasksProgression'
import LangContext from 'context/LangContext'
import MessageContext from 'context/MessageContext'
import LoadingContext from 'context/LoadingContext'
import UrlApis from 'utils/api/urlApis'
import AuthContext from 'context/AuthContext'
import { Typography } from '@airbus/components-react/components'

const WidgetProgression = ({ bdvnumdoc }) => {
  const { t } = useTranslation()

  const [data, setData] = useState()
  const [isLoadInProgressActive, setIsLoadInProgressActive] = useState(false)
  // Key counter for forcing gauge redraw on widget resizing
  const { lang } = useContext(LangContext)
  const { handleDisplayMessage } = useContext(MessageContext)
  const { handleLoadInProgress } = useContext(LoadingContext)
  const { handleRequestLogin } = useContext(AuthContext)

  /********
   * Synchronization of widget's data to keep track of them
   ********/

  const loadData = async () => {
    try {
      console.debug(
        'Widget <' +
          t('9500011') +
          '> :: called URL = ' +
          encodeURI(UrlApis.URL_WPSTATUS_PROGRESSION_GET + '?lang=' + lang + '&bdvnumdoc=' + bdvnumdoc),
      )
      const headerCompleted = await AxiosUtils.getHeader(AxiosUtils.HEADERS.HEADER_READ)
      const response = await axios.get(
        encodeURI(UrlApis.URL_WPSTATUS_PROGRESSION_GET + '?lang=' + lang + '&bdvnumdoc=' + bdvnumdoc),
        {},
        {
          headers: headerCompleted,
          withCredentials: false,
        },
      )

      // Init widget locally
      console.debug('data retrieved <' + t('9500011') + '>')
      // Fix-up potentially erroneous data between hhdone (true hours) and hhtotal (estimated hours): done hours must not be greater than total hours!
      const dataAdjusted = {
        ...response?.data,
        hhdone: response?.data?.hhdone > response?.data?.hhtotal ? response?.data?.hhtotal : response?.data?.hhdone,
      }

      setData(dataAdjusted)
    } catch (err) {
      console.debug('ERR <' + t('9500011') + '>: ' + err)
      if (err.response.status === HTTP_CODES.HTTP_CODE_SESSION_EXPIRED) {
        handleDisplayMessage(new Message(MessageSeverity.WARNING, t('9500011'), null, t('sessionExpired')))
        handleRequestLogin()
      } else if (err.response.status === HTTP_CODES.HTTP_CODE_NOT_FOUND) {
        handleDisplayMessage(new Message(MessageSeverity.ERROR, t('9500011'), null, t('9500173')))
      } else {
        handleDisplayMessage(
          new Message(
            MessageSeverity.ERROR,
            t('9500011'),
            err.response.data?.amasisCode,
            err.response.data?.description
              ? err.response.data?.description
              : err.response.data.title
                ? err.response.data.title
                : err.response.data.message
                  ? err.response.data.message
                  : err.response.data.error,
          ),
        )
      }
    } finally {
      handleLoadInProgress(false)
      setIsLoadInProgressActive(false)
    }
  }

  // Sync on receiving data from server (axios)
  useEffect(() => {
    if (bdvnumdoc !== undefined) {
      handleLoadInProgress(true)
      setIsLoadInProgressActive(true)
      loadData()
    }
  }, [bdvnumdoc])

  return (
    <div className='WidgetWpProgression'>
      <Typography variant='large' style={{ marginBottom: '20px' }}>
        {t('9500011')}
      </Typography>
      {data && JSON.stringify(data) !== '{}' && JSON.stringify(data) !== '[]' ? (
        <div>
          <div>
            <div className='progressionGauges'>
              <div className='gauge'>
                <GaugeTasksProgression
                  gaugeKey={'wpstatus_gauge_A_'}
                  title={t('9500024')}
                  tasksCompleted={data.itemsDone}
                  tasksTotal={data.itemsTotal}
                />
              </div>
              <div className='gauge'>
                <GaugeTasksProgression
                  gaugeKey={'wpstatus_gauge_B_'}
                  title={t('9500023')}
                  tasksCompleted={data.hhdone}
                  tasksTotal={data.hhtotal}
                />
                <div className='tasksWithoutMH'>
                  {t('9500095')}: {data.noHH}
                </div>
              </div>
            </div>
          </div>
          <div className='gaugesProgressionlegend'>
            <div className='tasksRealized'>{t('9500021')}</div>
            <div className='tasksToDo'>{t('9500022')}</div>
          </div>
        </div>
      ) : (
        <div style={{ paddingLeft: '1em' }}>{isLoadInProgressActive ? t('9500166') : t('9500055')}</div>
      )}
    </div>
  )
}

export default WidgetProgression
